import CaseStudyCard from "../../reusables/CaseStudyCard";
import flexipainters from "../../../assets/images/case-studies/flexipainters.jpg";

const FlexipaintersCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={flexipainters}
      client="Flexi Painters Kampala"
      solution="Digital Brand Resetup"
      title="Digital brand resetup & market repositioning of this professional painting company"
      subtitle="Flexi Painters Kampala needed more than just a new website but a complete digital brand reset."
      link="/case-studies/flexipainters"
    >
      <li>
        ✔︎ <span>Logo design</span> 
      </li>
      <li>
        ✔︎ <span>Website design</span>
      </li>
      <li>
        ✔︎ <span>Social media resetup</span>
      </li>
      <li>
        ✔︎ <span>Search Engine Optimization</span>
      </li>
      <li>
        ✔︎ <span>Facebook & Google Ads Setup</span>
      </li>
    </CaseStudyCard>
  );
};

export default FlexipaintersCaseStudyCard;
